/* tslint:disable */
/* eslint-disable */
/**
 * Finastic Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CommunicationChannel,
    CommunicationChannelFromJSON,
    CommunicationChannelFromJSONTyped,
    CommunicationChannelToJSON,
} from './CommunicationChannel';

/**
 * 
 * @export
 * @interface UpdateCommunicationChannelCommand
 */
export interface UpdateCommunicationChannelCommand {
    /**
     * 
     * @type {CommunicationChannel}
     * @memberof UpdateCommunicationChannelCommand
     */
    comminucationChannel?: CommunicationChannel;
}

export function UpdateCommunicationChannelCommandFromJSON(json: any): UpdateCommunicationChannelCommand {
    return UpdateCommunicationChannelCommandFromJSONTyped(json, false);
}

export function UpdateCommunicationChannelCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCommunicationChannelCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'comminucationChannel': !exists(json, 'comminucationChannel') ? undefined : CommunicationChannelFromJSON(json['comminucationChannel']),
    };
}

export function UpdateCommunicationChannelCommandToJSON(value?: UpdateCommunicationChannelCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'comminucationChannel': CommunicationChannelToJSON(value.comminucationChannel),
    };
}

